<template>
    <div>
        <div
            v-if="isClicked"
            style="
                background-color: #000000;
                text-align: center;
                padding-bottom: 5px;
            "
        >
            <v-icon class="image" color="white" @click.stop="edit">edit</v-icon>
        </div>
        <div class="notification-container" v-on:click="select($event)">
            <div style="color: black">
                <span>{{ booking.SupplierName }}</span>
                <span class="content-right">{{ booking.WaitingAreaName }}</span>
            </div>
            <div style="display: inline-flex; width: 100%">
                <div style="width: 40%">
                    <span class="instructions-text">{{
                        booking.Instructions
                    }}</span>
                </div>
                <div style="width: 60%">
                    <div>
                        <div
                            v-if="
                                booking.WANotificationImages &&
                                booking.WANotificationImages.length > 0
                            "
                            style="display: inline-flex"
                        >
                            <v-icon class="image" color="white"
                                >collections</v-icon
                            >
                            <div class="image-count">
                                {{ booking.WANotificationImages.length }}
                            </div>
                        </div>
                        <div>
                            <span class="status-banner">{{
                                trans(
                                    'form.label.' +
                                        currentBookingType.toLowerCase()
                                )
                            }}</span>
                        </div>
                        <div
                            v-if="
                                booking.UnReadCount && booking.UnReadCount > 0
                            "
                            style="float: right; margin-right: 5px"
                        >
                            <v-badge
                                color="red"
                                style="width: 29px; margin-top: 5px"
                            >
                                <template v-slot:badge>
                                    <span>{{ booking.UnReadCount }}</span>
                                </template>
                                <v-icon style="color: black">message</v-icon>
                            </v-badge>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Tooltip view -->
        <div class="tippy-popper" ref="tooltip" v-if="booking">
            <v-card class="white--text v-card-round" width="700">
                <v-card-title
                    style="color: black"
                    primary-title
                    :style="{ background: color }"
                >
                    <v-layout style="width: 100%">
                        <v-flex xs4
                            ><div class="subheading mb-3">
                                {{ booking.BookingReference }}
                            </div></v-flex
                        >
                        <v-flex xs6
                            ><div
                                style="
                                    background: #000000;
                                    padding: 10px;
                                    font-weight: bold;
                                    font-size: 18px;
                                    color: #ffffff;
                                "
                            >
                                {{
                                    trans(
                                        'form.label.' +
                                            currentBookingType.toLowerCase()
                                    )
                                }}
                            </div></v-flex
                        >
                        <v-flex xs2>
                            <v-btn
                                align-end
                                class="tippy-close-btn"
                                @click="openChat(booking)"
                                icon
                                small
                            >
                                <v-icon style="color: #000000">message</v-icon>
                            </v-btn>
                            <v-btn
                                align-end
                                class="tippy-close-btn"
                                @click="
                                    subscribeNotifications(booking.IsSubscribed)
                                "
                                icon
                                small
                            >
                                <v-icon style="color: #000000">{{
                                    booking.IsSubscribed
                                        ? 'notifications_active'
                                        : 'notifications_off'
                                }}</v-icon>
                            </v-btn>
                            <v-btn
                                align-end
                                class="tippy-close-btn"
                                @click="fireEvent()"
                                icon
                                small
                            >
                                <v-icon style="color: #000000">edit</v-icon>
                            </v-btn>
                            <v-btn
                                align-end
                                class="tippy-close-btn"
                                @click="tippy.hide()"
                                icon
                                small
                            >
                                <v-icon style="color: #000000">clear</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                    <v-layout
                        style="width: 100%"
                        v-if="currentBookingType !== 'EXPECTED'"
                    >
                        <v-flex xs4>
                            <v-layout row wrap>
                                <v-flex xs5 class="subheading mb-1">{{
                                    trans('form.label.pinCode')
                                }}</v-flex>
                                <v-flex xs7 class="subheading mb-1"
                                    >: {{ booking.PinCode }}</v-flex
                                >
                                <v-flex xs5 class="subheading mb-1">{{
                                    trans('form.label.bookedBy')
                                }}</v-flex>
                                <v-flex xs7 class="subheading mb-1"
                                    >: {{ booking.CreatedByUserName }}</v-flex
                                >
                            </v-layout>
                        </v-flex>
                        <v-flex xs6>
                            <viewer
                                :images="booking.WANotificationImages"
                                :options="viewerOptions"
                            >
                                <div
                                    class="file-placeholder-display-img-wrapper"
                                    v-for="(
                                        fileItem, idx
                                    ) in booking.WANotificationImages"
                                    :key="'display-' + idx"
                                >
                                    <img
                                        v-if="fileItem.ImagePath"
                                        :key="fileItem.ImageId"
                                        :src="fileItem.ImagePath"
                                        :title="fileItem.ImageId"
                                        @error="imageUrlAlt"
                                        class="file-placeholder-display-img"
                                    />
                                </div>
                            </viewer>
                        </v-flex>
                        <v-flex xs2>
                            <v-layout row wrap>
                                <v-flex xs12 class="subheading mb-1">
                                    {{ booking.UnloadingAreaName }}
                                </v-flex>
                                <v-flex xs12 class="subheading mb-1">
                                    {{ booking.WaitingAreaName }}
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-title>
                <v-card-text
                    class="pa-3 white black--text"
                    v-if="this.booking.Status !== 3"
                >
                    <el-row>
                        <el-col :span="20">
                            <el-row>
                                <el-col :span="2">{{
                                    trans('form.label.from')
                                }}</el-col>
                                <el-col :span="6">
                                    <el-date-picker
                                        style="width: 130px"
                                        v-model="fromDate"
                                        size="mini"
                                        type="date"
                                        prefix-icon=""
                                        :clearable="false"
                                        placeholder="Start Date"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-col>
                                <el-col :span="4">
                                    <el-time-select
                                        style="width: 95px"
                                        placeholder="Start time"
                                        @change="onFromTimeChange"
                                        v-model="fromTime"
                                        :clearable="false"
                                        size="mini"
                                        :picker-options="{
                                            format: 'HH:mm:ss',
                                            start: '00:00',
                                            step: timeStepper,
                                            end: '23:30',
                                        }"
                                    >
                                    </el-time-select>
                                </el-col>
                                <el-col :span="2">
                                    <span style="padding-left: 15px">{{
                                        trans('form.label.to')
                                    }}</span>
                                </el-col>
                                <el-col :span="6">
                                    <el-date-picker
                                        style="width: 130px"
                                        v-model="toDate"
                                        size="mini"
                                        type="date"
                                        :clearable="false"
                                        placeholder="End Date"
                                        :picker-options="pickerOptions"
                                    >
                                    </el-date-picker>
                                </el-col>
                                <el-col :span="4">
                                    <el-time-select
                                        style="width: 95px"
                                        placeholder="End time"
                                        v-model="toTime"
                                        size="mini"
                                        :clearable="false"
                                        :picker-options="{
                                            start: '00:00',
                                            step: timeStepper,
                                            end: '23:30',
                                        }"
                                    >
                                    </el-time-select>
                                </el-col>
                            </el-row>
                        </el-col>

                        <el-col :span="3">
                            <v-btn
                                v-if="booking.Status !== 1"
                                color="primary"
                                @click="changeStatus(1)"
                                style="max-width: 115px; margin-left: 10px"
                                >{{ trans('button.text.confirm2') }}</v-btn
                            >
                            <v-btn
                                v-if="booking.Status !== 2"
                                @click="changeStatus(2)"
                                color="error"
                                style="
                                    margin-top: 5px;
                                    max-width: 115px;
                                    margin-left: 10px;
                                "
                            >
                                {{ trans('button.text.deny') }}
                            </v-btn>
                        </el-col>
                    </el-row>
                    <v-layout
                        class="mt-3"
                        v-for="(
                            packageGroup, index
                        ) in booking.PackageGroups.slice().reverse()"
                        :key="packageGroup.PackageGroupID"
                    >
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('data.label.referenceNo') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('data.label.supplier') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('data.label.items') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ packageGroup.Reference }}
                                </div>
                                <div class="body-1">
                                    : {{ packageGroup.SupplierName }}
                                </div>
                                <div class="body-1">
                                    <p
                                        v-for="(
                                            packageItem, index
                                        ) in packageGroup.PackageItems"
                                        :key="index"
                                    >
                                        :
                                        {{
                                            `${packageItem.Description} ${
                                                packageItem.PackageType
                                                    ? `(${packageItem.PackageType})`
                                                    : ''
                                            }`
                                        }}
                                    </p>
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3 v-if="index === 0">
                            <div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientName') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientCompany') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.recipientPhone') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex
                            xs3
                            v-if="index === 0 && booking.AccessSets.length"
                        >
                            <div>
                                <div class="body-1">
                                    : {{ booking.AccessSets[0].RecipientName }}
                                </div>
                                <div class="body-1">
                                    :
                                    {{ booking.AccessSets[0].RecipientCompany }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.AccessSets[0].RecipientPhone }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout style="padding-top: 15px">
                        <v-flex xs3>
                            <div class="body-1">
                                {{ trans('table.column.comments') }}
                            </div>
                        </v-flex>
                        <v-flex xs9>
                            <div class="body-1">: {{ booking.Comment }}</div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-title
                    primary-title
                    :style="{ background: '#5D5E61' }"
                    v-if="currentBookingType !== 'EXPECTED'"
                >
                    <v-layout>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('form.label.usageTime') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.maxUsageTime') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.numberPlate') }}
                                </div>
                                <div v-if="booking.IsLocked" class="body-1">
                                    <i
                                        class="material-icons"
                                        v-if="booking.IsLocked"
                                        style="font-size: 16px"
                                    >
                                        lock
                                    </i>
                                    {{ trans('form.label.locked') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ booking.UsageTimes }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.MaxUsageTimes }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.PlateNo }}
                                </div>
                                <div v-if="booking.IsLocked" class="body-1">
                                    : {{ booking.LockedByUserName }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    {{ trans('table.column.preFlex') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.unloadingTimeInMin') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.created') }}
                                </div>
                                <div class="body-1">
                                    {{ trans('form.label.updated') }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs3>
                            <div>
                                <div class="body-1">
                                    : {{ getPreFlex(booking) }} mins
                                </div>
                                <div class="body-1">
                                    : {{ booking.UnloadingTimeInMins }} mins
                                </div>
                                <div class="body-1">
                                    : {{ booking.Created | formatDateTime }}
                                </div>
                                <div class="body-1">
                                    : {{ booking.Updated | formatDateTime }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-title>
            </v-card>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'
import tippy from 'tippy.js'
import 'viewerjs/dist/viewer.css'
import moment from 'moment'
import { DateTime } from 'luxon'
import WANotificationsMixin from '../../mixins/waiting-area-notifications-mixin'
import ChatMixin from '../../mixins/chat-mixin'

export default {
    name: 'wa-notification-event',

    props: {
        booking: {
            type: Object,
            default: () => null,
        },

        selectedContainer: {
            type: Object,
            default: () => null,
        },

        element: {
            type: Object,
            default: () => {},
        },

        trans: {
            default: () => null,
        },

        unloadingArea: {
            type: Object,
            default: () => null,
        },

        readonly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        let dateTimeFormat = process.env.VUE_APP_DATETIME_FORMAT

        return {
            isClicked: false,
            currentBorderColor: '',
            currentBorderStyle: 'solid',
            fromDate: '',
            toDate: '',
            fromTime: '',
            toTime: '',
            timeStepper: '00:30',
            isValidDateRange: true,
            defaultTimeStep: 15,
            viewerOptions: {
                toolbar: true,
                movable: true,
                zoomable: true,
                scalable: false,
                rotatable: false,
                fullscreen: false,
                title: false,
            },
            dateTimeFormat,
            initialStartDate: '',
            initialEndDate: '',
            currentBookingType: '',
        }
    },

    mixins: [WANotificationsMixin, ChatMixin],

    watch: {
        fromDate: _.debounce(function (value, oldValue) {
            if (oldValue && value) {
                this.validateDateRange()
            }
        }, 2000),
        fromTime: _.debounce(function (value, oldValue) {
            if (oldValue && value) {
                this.validateDateRange()
            }
        }, 2000),
        toDate: _.debounce(function (value, oldValue) {
            if (oldValue && value) {
                this.validateDateRange()
            }
        }, 2000),
        toTime: _.debounce(function (value, oldValue) {
            if (oldValue && value) {
                this.validateDateRange()
            }
        }, 2000),
    },

    computed: {
        color() {
            let color = '#C9C9C9'
            if (this.booking.Status === 0) {
                color = '#fffe40'
            } else if (this.booking.Status === 1) {
                color = '#3fd2be'
            } else if (this.booking.Status === 2) {
                color = '#f80701'
            } else if (this.booking.Status === 3) {
                color = '#30b1ea'
            }
            return color
        },
        packageGroups() {
            return this.booking.PackageGroups
                ? this.booking.PackageGroups.slice().reverse()
                : []
        },
        pickerOptions() {
            return {
                firstDayOfWeek: 1,
            }
        },
    },

    created() {
        this.currentBookingType = this.getWAStatusDescription(
            this.booking.Status
        )

        if (this.booking.DateFrom && this.booking.DateTo) {
            this.initialStartDate = DateTime.fromISO(
                this.booking.DateFrom
            ).toFormat(this.dateTimeFormat)
            this.initialEndDate = DateTime.fromISO(
                this.booking.DateTo
            ).toFormat(this.dateTimeFormat)
            this.showDateInPickers([
                moment(this.initialStartDate),
                moment(this.initialEndDate),
            ])
        }
    },

    mounted() {
        this.addStyles()
        this.tippy = tippy.one(this.element.get(), {
            arrow: true,
            arrowTransform: 'scale(1.2)',
            html: this.$refs.tooltip.firstChild,
            interactive: true,
            livePlacement: false,
            duration: 100,
            trigger: 'manual',
            hideOnClick: 'false',
            zIndex: 100,
        })

        this.$once('hook:beforeDestroy', () => {
            this.tippy.destroy()
        })

        Events.$on('unselect', (selectedWaNotificationId) => {
            if (
                selectedWaNotificationId &&
                selectedWaNotificationId !== this.booking.WANotificationID
            ) {
                this.isClicked = false
                this.unselect()
            }
        })
    },

    methods: {
        fireEvent() {
            this.tippy.hide()
            this.$emit('actor-editing', this.booking)
        },

        addStyles() {
            this.element.css('border-width', '2px')
            if (this.booking.Status === 2) {
                this.element.css('background-color', '#f80701')
                this.element.css('border-color', '#f80701')
                this.element.css('border-style', 'solid')
                this.currentBorderColor = '#f80701'
                this.currentBorderStyle = 'solid'
            } else if (this.booking.Status === 1) {
                this.element.css('background-color', '#3fd2be')
                this.element.css('border-color', '#3fd2be')
                this.element.css('border-style', 'solid')
                this.currentBorderColor = '#3fd2be'
                this.currentBorderStyle = 'solid'
            } else if (this.booking.Status === 3) {
                this.element.css('background-color', '#30b1ea')
                this.element.css('border-color', '#ffffff')
                this.element.css('border-style', 'dashed')
                this.currentBorderColor = '#ffffff'
                this.currentBorderStyle = 'dashed'
            } else if (this.booking.Status === 0) {
                this.element.css('background-color', '#fffe40')
                this.element.css('border-color', '#000000')
                this.element.css('border-style', 'dashed')
                this.currentBorderColor = '#000000'
                this.currentBorderStyle = 'dashed'
            } else {
                this.element.css('background-color', '#C9C9C9')
                this.element.css('border-color', '#C9C9C9')
                this.element.css('border-style', 'solid')
                this.currentBorderColor = '#C9C9C9'
                this.currentBorderStyle = 'solid'
            }
        },
        select() {
            // Unselect already selected WA Notifications except the current one
            Events.$emit('unselect', this.booking.WANotificationID)

            // Unhighlight already selected actors
            Events.$emit('unhighlight', this.booking.ActorID)

            Events.$emit('highlight', this.booking.ActorID)

            // Scroll calendar to the actor event
            if (this.booking.DateFrom) {
                Events.$emit('scroll-calendar', this.booking.DateFrom.hour)
            }

            // Enable Toggle mode hence no need to refresh calendar to unselect.
            this.isClicked = !this.isClicked

            if (this.isClicked) {
                this.element.css('border-width', '3px')
                this.element.css('border-color', '#000000')
                this.element.css('border-style', 'solid')
            } else {
                this.unselect()
            }
        },

        unselect() {
            this.element.css('border-width', '2px')
            this.element.css('border-color', this.currentBorderColor)
            this.element.css('border-style', this.currentBorderStyle)
        },

        edit() {
            this.tippy.show()
        },

        getPreFlex(b) {
            let preFlex =
                b.AccessSets &&
                b.AccessSets[0] &&
                b.AccessSets[0].Schedules &&
                b.AccessSets[0].Schedules[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0] &&
                b.AccessSets[0].Schedules[0].ScheduleParts[0].PreFlex

            return preFlex || 0
        },

        async changeStatus(status) {
            const message =
                status === 2
                    ? 'message.warning.deny'
                    : 'message.warning.confirm'
            try {
                await this.$confirm(this.trans(message), 'Warning', {
                    confirmButtonText: this.trans('button.text.confirm'),
                    cancelButtonText: this.trans('button.text.cancel'),
                    type: 'warning',
                })
                this.updateStatus(status)
                return true
            } catch (e) {
                console.error(e)
                return false
            }
        },

        async updateStatus(status) {
            try {
                await this.$http.post(
                    `/WANotification/${this.booking.WANotificationID}/Status`,
                    {
                        Status: status,
                    }
                )

                this.$message({
                    type: 'success',
                    showClose: true,
                    message: this.trans('message.success.updated', {
                        section: this.trans('text.booking'),
                    }),
                })

                Events.$emit('actor-updated')
            } catch (error) {
                console.error(error)
                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.trans('message.error.general'),
                })
            }
        },

        onFromTimeChange(currentTime) {
            if (currentTime && currentTime.includes(':')) {
                let timeArr2 = currentTime.split(':')
                let hour2 = timeArr2[0]
                let minutes2 = timeArr2[1]

                // TODO fix the logic. If edit mode add difference of selected time in minutes
                let minutesToAdded

                minutesToAdded = moment
                    .duration(
                        moment(this.dateRange[1]).diff(
                            moment(this.dateRange[0])
                        )
                    )
                    .asMinutes()

                this.toTime = moment({ hours: hour2, minutes: minutes2 })
                    .add(minutesToAdded, 'minutes')
                    .format('HH:mm')
            }
        },
        // Validate selected date range
        validateDateRange() {
            if (
                !this.fromDate ||
                !this.toDate ||
                !this.fromTime ||
                !this.toTime
            ) {
                this.isValidDateRange = false
                return
            }

            let finalFromDate
            let finalToDate

            let timeArr1 = this.fromTime.split(':')
            let hour1 = timeArr1[0]
            let minutes1 = timeArr1[1]
            finalFromDate = moment(this.fromDate, 'MM-DD-YYYY')
                .add(hour1, 'hours')
                .add(minutes1, 'minutes')

            let timeArr2 = this.toTime.split(':')
            let hour2 = timeArr2[0]
            let minutes2 = timeArr2[1]
            finalToDate = moment(this.toDate, 'MM-DD-YYYY')
                .add(hour2, 'hours')
                .add(minutes2, 'minutes')

            if (!finalFromDate.isBefore(finalToDate)) {
                this.isValidDateRange = false
                this.dateTimeRange = []

                this.$message({
                    type: 'error',
                    showClose: true,
                    message: this.trans('form.label.dateRangeValidationError'),
                })
            } else {
                this.isValidDateRange = true
                this.dateTimeRange = [finalFromDate, finalToDate]

                if (
                    finalFromDate.toDate().getTime() !==
                        moment(this.initialStartDate).toDate().getTime() ||
                    finalToDate.toDate().getTime() !==
                        moment(this.initialEndDate).toDate().getTime()
                ) {
                    this.$message({
                        type: 'info',
                        showClose: true,
                        message: 'Updating Calendar. Please wait...',
                    })

                    this.booking.start = moment(finalFromDate)
                    this.booking.end = moment(finalToDate)
                    this.$emit('update-booking', this.booking)
                }
            }
        },

        showDateInPickers(dateRange) {
            this.dateTimeRange = dateRange
            let sdt = dateRange[0]
            let edt = dateRange[1]

            let sd = sdt.toDate()
            sd.setHours(0)
            sd.setMinutes(0)
            sd.setSeconds(0)

            let ed = edt.toDate()
            ed.setHours(0)
            ed.setMinutes(0)
            ed.setSeconds(0)

            this.fromDate = sd
            this.toDate = ed

            this.fromTime = this.addLeadingZeros(sdt.hour(), sdt.minutes())
            this.toTime = this.addLeadingZeros(edt.hour(), edt.minutes())
        },

        addLeadingZeros(hour, minutes) {
            let fh, fm
            if (hour >= 0 && hour <= 9) {
                fh = '0' + hour
            } else {
                fh = hour
            }
            if (minutes >= 0 && minutes <= 9) {
                fm = '0' + minutes
            } else {
                fm = minutes
            }
            return fh + ':' + fm
        },

        imageUrlAlt(event) {
            event.target.src = '/images/icon/image-white-icon.png'
        },

        async openChat(booking) {
            let channelId = booking.ChannelId
            if (!channelId) {
                channelId = await this.createChannel(booking)
            }
            if (channelId) {
                Events.$emit('show-chat', true)
                this.$nextTick(() => {
                    Events.$emit('open-chat', true, channelId)
                    this.tippy.hide()
                })
            }
        },

        subscribeNotifications(isSubscribed) {
            isSubscribed = !isSubscribed
            if (isSubscribed) {
                this.$http.post(`/NotificationSubscription/Subscribe`, {
                    LogLevel: 'INFO',
                    ReferenceCode: this.booking.ReferenceCode,
                    Data: this.booking.WANotificationID,
                })
            } else {
                this.$http.delete(
                    `/NotificationSubscription/ReferenceCode/${this.booking.ReferenceCode}/Data/${this.booking.WANotificationID}/UnSubscribe/LogLevel/Info`
                )
            }
            this.booking.IsSubscribed = isSubscribed
        },
    },
}
</script>
<style>
.el-picker-panel {
    z-index: 9999 !important;
}
</style>
<style scoped>
.notification-container {
    padding: 2px;
    min-height: 34px;
    font-size: 12px;
    color: #ffffff;
}
.image {
    font-size: 20px;
}
.image-count {
    font-size: 10px;
    width: 15px;
    height: 15px;
    background: #f80701;
    border-color: #f80701;
    margin-left: 3px;
    margin-top: 3px;
    border-radius: 50%;
    line-height: 15px;
    text-align: center;
    font-weight: bold;
}
.instructions-text {
    white-space: pre-wrap;
    word-break: break-word;
    color: black;
}
.content-right {
    float: right;
}
.status-banner {
    background-color: #000;
    padding: 3px;
    margin: 1px 0;
}

.v-card-round {
    border-radius: 10px;
}
.tippy-tooltip {
    color: inherit !important;
    font-size: inherit !important;
    padding: 0 !important;
    max-width: inherit !important;
    text-align: inherit !important;
    background-color: transparent !important;
}
.tippy-popper {
    margin-top: 50px;
}
.tippy-popper[x-placement^='top'] .tippy-arrow {
    border-top-color: #eeeeee !important;
}
.tippy-popper[x-placement^='bottom'] .tippy-arrow {
    border-bottom-color: #eeeeee !important;
}
.tippy-popper[x-placement^='left'] .tippy-arrow {
    border-left-color: #eeeeee !important;
}
.tippy-popper[x-placement^='right'] .tippy-arrow {
    border-right-color: #eeeeee !important;
}
.text_bold {
    font-weight: bold !important;
    text-shadow: 0.5px 0.5px #323b49;
}
.text_not_bold {
    font-weight: normal !important;
    text-shadow: none;
}
.file-placeholder-display-img {
    width: 60px;
    height: 60px;
    font-size: 30px;
    text-align: center;
    position: absolute;
    right: 0px;
    cursor: pointer;
}
.file-placeholder-display-img-wrapper {
    position: relative;
    float: left;
    width: 60px;
    height: 60px;
    margin-left: 8px;
    margin-top: 8px;
}
</style>